// @flow

export default (block: string, ...modifiers: any[]) =>
  [`${block}`]
    .concat(modifiers.filter(Boolean).map(m => `${block}--${m}`))
    .join(' ')



// WEBPACK FOOTER //
// ./src/lib/bem.js